import React from 'react'
import SimplePage from '../layouts/simplePage'

const FAQPage = () => {
    return (
        <SimplePage
            image={require('../assets/images/carlous-img3.jpg')}
            title={'FAQS'}
        >
            <p>
                IATA Accredited, Active Member of Indian Association of Tour
                Operators (IATO) & Travel Agent Federation of India (TAFI), an
                ISO 9001-2015 Certified Travel Company
            </p>
            <h5>The info will be updated soon</h5>
        </SimplePage>
    )
}

export default FAQPage
